import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Links Icon
 *
 * @file Links.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Links = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8743 4.005C15.6329 4.005 17.8693 6.24133
        17.8693 9C17.8693 11.7587 15.6329 13.995 12.8743
        13.995H11.0057C10.5225 13.995 10.1307 13.6032 10.1307
        13.12C10.1307 12.6367 10.5225 12.245 11.0057
        12.245H12.8743C14.6664 12.245 16.1193 10.7922
        16.1193 9C16.1193 7.20783 14.6664 5.755 12.8743
        5.755H11.0057C10.5225 5.755 10.1307 5.36325 10.1307
        4.88C10.1307 4.39675 10.5225 4.005 11.0057
        4.005H12.8743ZM6.99428 4.005C7.47753 4.005
        7.86928 4.39675 7.86928 4.88C7.86928 5.36325
        7.47753 5.755 6.99428 5.755H5.12571C3.33354
        5.755 1.88071 7.20783 1.88071 9C1.88071 10.7922
        3.33354 12.245 5.12571 12.245H6.99428C7.47753 12.245
        7.86928 12.6367 7.86928 13.12C7.86928 13.6032 7.47753
        13.995 6.99428 13.995H5.12571C2.36704 13.995 0.130707
        11.7587 0.130707 9C0.130707 6.24133 2.36704 4.005
        5.12571 4.005H6.99428ZM12 8C12.5523 8 13 8.44771 13 9C13
        9.55228 12.5523 10 12 10H5.99999C5.44771 10 4.99999
        9.55228 4.99999 9C4.99999 8.44771 5.44771 8 5.99999 8H12Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Links;
